module.exports = __webpack_public_path__ + "img/s3-3.12291ef7.svg";